import { useState } from 'react'
import { TeamLevelDialog, WhatsThis } from './'

export const TeamLevelDescriptions = ({ ...props }) => {
  const [teamDescriptionsOpen, setTeamDescriptionsOpen] = useState(false)

  return (
    <>
      <TeamLevelDialog
        open={teamDescriptionsOpen}
        onClose={() => setTeamDescriptionsOpen(false)}
        mobileBackground="white"
      />
      <WhatsThis
        onClick={() => setTeamDescriptionsOpen(true)}
        text="I don't know the difference"
        {...props}
      />
    </>
  )
}